import home from './src/home.vue'
import EquipmentView from './src/EquipmentMonitor/EquipmentView.vue' //设备信息列表页
import EquipmentInfo from './src/EquipmentMonitor/EquipmentInfo.vue' //设备信息详情页
import EquipmentMonitorView from './src/EquipmentMonitor/EquipmentMonitorView.vue' //设备信息详情页

let views = {
    home,
    EquipmentView,
    EquipmentInfo,
    EquipmentMonitorView
};

export default views;